<template>
    <v-form ref="passwordForm" v-model="validPasswordForm" lazy-validation>
        <p class="text-body-2 mb-1">
            {{ $t('user_settings.change_password.current_password_field') }}
        </p>
        <v-text-field
            v-model="currentPassword"
            :rules="[rules.required]"
            :append-inner-icon="showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showCurrentPassword ? 'text' : 'password'"
            autocomplete="current-password"
            class="w-100"
            required
            maxlength="50"
            counter
            density="compact"
            variant="outlined"
            @click:append-inner="showCurrentPassword = !showCurrentPassword"
        ></v-text-field>
        <p class="text-body-2 mb-1">
            {{ $t('user_settings.change_password.new_password_field') }}
        </p>
        <v-text-field
            v-model="newPassword"
            :rules="rules.password_confirmation_rule"
            :append-inner-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showNewPassword ? 'text' : 'password'"
            autocomplete="new-password"
            class="w-100"
            required
            maxlength="50"
            density="compact"
            counter
            variant="outlined"
            @click:append-inner="showNewPassword = !showNewPassword"
        ></v-text-field>
        <p class="text-body-2 mb-1">
            {{ $t('user_settings.change_password.confirm_new_password_field') }}
        </p>
        <v-text-field
            v-model="confirmPassword"
            :rules="[rules.required, password_match_rule]"
            :append-inner-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showConfirmPassword ? 'text' : 'password'"
            block
            class="w-100"
            autocomplete="new-password"
            required
            maxlength="50"
            density="compact"
            counter
            variant="outlined"
            @click:append-inner="showConfirmPassword = !showConfirmPassword"
        ></v-text-field>

        <ButtonComponent
            color="primary"
            :disabled="!validPasswordForm"
            :loading="loading"
            @click="changePassword"
        >
            {{ $t('user_settings.change_password.change_password_button') }}
        </ButtonComponent>
    </v-form>
</template>

<script>
import { useUserStore } from '@/stores/user';
import { toast } from 'vue3-toastify';
import { defaultErrorHandling } from '@/assets/js/utils';
import ButtonComponent from '@/components/utils/buttons/ButtonComponent.vue';

export default {
    name: 'ChangePassword',
    components: {
        ButtonComponent,
    },
    data: () => ({
        user_store: useUserStore(),
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        validPasswordForm: false,
        showCurrentPassword: false,
        showNewPassword: false,
        showConfirmPassword: false,
        loading: false,
        rules: {
            required: (value) => !!value || 'Must be specified.',
            password_confirmation_rule: [
                (v) => !!v || 'Must be specified.',
                (v) => (v && v.length >= 8) || 'Minimum 8 characters',
                (v) => (v && /\d/.test(v)) || 'Password must contain a number.',
                (v) =>
                    (v && /[ `!@#$%^&§*()_+\-=[\]{};':"\\|,.<>/?~]/.test(v)) ||
                    'Password must contain a special character.',
            ],
        },
    }),
    methods: {
        async changePassword() {
            const valid = await this.$refs.passwordForm.validate();
            if (valid) {
                this.loading = true;
                this.user_store
                    .change_password(this.newPassword, this.currentPassword)
                    .then(() => {
                        toast.success(this.$t('alerts.success.password_changed'));
                    })
                    .catch(defaultErrorHandling())
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                toast.error(this.$t('alerts.error.please_check_your_input'));
            }
        },
        password_match_rule(v) {
            if (v === this.newPassword) return true;

            return this.$t('alerts.error.passwords_do_not_match');
        },
    },
};
</script>

<style></style>
